import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";
import { Tooltip } from "antd";
import styled from "styled-components";
import ChartGauge from "../../../common/charts/ChartGauge";

// #region SCOPED CSS
const ShelfSpeedStyled = styled.div`
    & {
        display: flex;
        flex-direction: row;
        gap: 16px;
    }

    .shelf-speed-container {
        display: flex;
        flex-direction: column;
        padding: 10px 16px;
        align-items: flex-start;
        justify-content: space-between;
        border-radius: 4px;
        border: 1px solid var(--backgrounds-lines-n-100, #3c485a);
        background: var(--backgrounds-lines-n-300, #1a222d);
        height: 298px;
        width: 234px;
    }
    .title {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .chart-kp-is2 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        height: 278px;
        position: relative;
    }
    .total-score {
        padding: 0px 0px 10px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .total-score2 {
        padding: 10px 0px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 56px;
        align-items: start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame2 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle5 {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
    }
    .content3 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 69px;
        position: relative;
    }
    .frame-29 {
        border-radius: 500px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 78px;
        height: 78px;
        position: relative;
        object-fit: cover;
        aspect-ratio: 1;
    }
    .svg5 {
        flex-shrink: 0;
        width: 129px;
        height: 69px;
        position: relative;
        overflow: hidden;
    }

    .frame-3132893 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: -0.72%;
        top: 0.72%;
    }
    .shelf-speed {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: center;
        font-size: 22px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        flex: 1;
        width: 128px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
    }
    .fast-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .medium-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-orange-500, #f90)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .slow-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-red-500, #ff3636)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .line2 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
        border: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
        width: 100%;
    }
    .reorders-expected {
        padding: 10px 0px 0px 0px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .total-score3 {
        display: flex;
        flex-direction: row;
        gap: 18px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame3 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 93px;
        overflow: hidden;
    }
    .info-circle6 {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
    }
    .frame-3132894 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    ._93-9 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    ._93-9-span {
        font-size: 35px;
        letter-spacing: -0.005em;
        font-weight: 400;
    }
    ._93-9-span2 {
        font-size: 21px;
        letter-spacing: -0.005em;
        font-weight: 400;
    }
    .heading-4-total-visitors3 {
        color: ${props =>
            props.enabled ? "var(--text-icons-gray-100, #d1d1d1)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 11px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .info-circle7 {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
    }
    ._102 {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: left;
        font-size: 35px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    //
    .small-box {
        display: flex;
        flex-direction: column;
        padding: 16px;
        align-items: flex-start;
        justify-content: space-between;
        border-radius: 4px;
        border: 1px solid var(--backgrounds-lines-n-100, #3c485a);
        background: var(--backgrounds-lines-n-300, #1a222d);
        height: 141px;
    }
    .small-boxs-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 98px;
        height: 100%;
    }
    .small-box-value {
        color: var(--text-icons-green-500, #0b0);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.24px;
    }
    .small-box-title {
        color: var(--text-icons-gray-100, #d1d1d1);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.035px;
    }
    .small-box-value.disabled,
    .small-box-title.disabled {
        color: var(--text-icons-gray-300, #4f5b6d);
    }

    //enabled-form
    .enabled-form .heading-4-total-visitors2 {
        color: var(--text-icons-gray-100, #d1d1d1);
    }

    .shelf-speed {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
        text-align: center;
        font-size: 22px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        flex: 1;
        width: 128px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
    }
    .fast-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-green-500, #00b00)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .medium-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-orange-500, #f90)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
    .slow-mover {
        color: ${props =>
            props.enabled ? "var(--text-icons-red-500, #ff3636)" : "var(--text-icons-gray-300, #4f5b6d)"};
    }
`;
// #endregion

export const ShelfSpeedAndStock = ({ productData, pageEnabled }) => {
    // if (productData) productData.shelfSpeed = "Fast"; //TESTING

    return (
        <ShelfSpeedStyled enabled={pageEnabled}>
            <div className="small-boxs-container">
                <div className="small-box">
                    <div className={`small-box-value ${pageEnabled ? "" : "disabled"}`}>
                        {productData?.totalStoresWithStock ?? "--"}
                    </div>
                    <div className={`small-box-title ${pageEnabled ? "" : "disabled"}`}>
                        In
                        <br />
                        stores
                    </div>
                </div>
                <div className="small-box">
                    <div className={`small-box-value ${pageEnabled ? "" : "disabled"}`}>
                        {productData?.totalStock ?? "--"}
                    </div>
                    <div className={`small-box-title ${pageEnabled ? "" : "disabled"}`}>
                        Overall
                        <br />
                        stock
                    </div>
                </div>
            </div>

            <div className={`shelf-speed-container ${pageEnabled ? "enabled-form" : ""}`}>
                <div className="chart-kp-is2" style={{ width: "100%" }}>
                    <div className="total-score">
                        <div className="total-score2">
                            <div className="frame2">
                                <div className="title">
                                    <div className="heading-4-total-visitors2">MARKET SHELF SPEED</div>
                                    <Tooltip
                                        color="#10141b"
                                        overlayInnerStyle={{ textAlign: "center" }}
                                        title={
                                            <>
                                                Overall speed label (Fast / Watch List / Slow) derived from the scoring
                                                model that combines STR, DOC and ACCEL. Used to trigger actions (e.g.,
                                                reorder vs activation).
                                            </>
                                        }>
                                        <InfoCircle
                                            className={`info-circle5 ${pageEnabled ? "text-white" : "text-inactive"}`}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="content3">
                                    <div className="frame-29">
                                        <ChartGauge
                                            index={Math.random()}
                                            value={
                                                productData?.shelfSpeed === "Fast"
                                                    ? 88
                                                    : productData?.shelfSpeed === "Watchlist" ||
                                                        productData?.shelfSpeed === "Watch List"
                                                      ? 50
                                                      : 15
                                            }
                                            enabled={
                                                pageEnabled &&
                                                ["Fast", "Watchlist", "Watch List", "Slow"].includes(
                                                    productData?.shelfSpeed
                                                )
                                            }
                                        />
                                    </div>

                                    <div className="svg5">
                                        <div className="frame-3132893">
                                            <div
                                                className={`shelf-speed ${
                                                    productData?.shelfSpeed === "Fast"
                                                        ? "fast-mover"
                                                        : productData?.shelfSpeed === "Watchlist" ||
                                                            productData?.shelfSpeed === "Watch List"
                                                          ? "medium-mover"
                                                          : productData?.shelfSpeed === "Slow"
                                                            ? "slow-mover"
                                                            : "text-inactive"
                                                }`}>
                                                {!["Fast", "Watchlist", "Watch List", "Slow"].includes(
                                                    productData?.shelfSpeed
                                                ) ? (
                                                    "--"
                                                ) : productData?.shelfSpeed === "Watchlist" ||
                                                  productData?.shelfSpeed === "Watch List" ? (
                                                    <>
                                                        WATCH
                                                        <br />
                                                        LIST
                                                    </>
                                                ) : (
                                                    `${productData?.shelfSpeed} MOVER`
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="line2" />
                    <div className="reorders-expected">
                        <div className="total-score3">
                            <div className="frame3">
                                <div className="title">
                                    <div className="heading-4-total-visitors2">% OUT</div>
                                    <Tooltip
                                        color="#10141b"
                                        overlayInnerStyle={{ textAlign: "center" }}
                                        title={
                                            <>
                                                Share of total received stock that is <b>no longer on hand</b>{" "}
                                                (sold-through) for the selected scope.
                                            </>
                                        }>
                                        <InfoCircle
                                            className={`info-circle6 ${pageEnabled ? "text-white" : "text-inactive"}`}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="content3">
                                    <div className="frame-3132894">
                                        <div className="_93-9">
                                            <span>
                                                <span className="_93-9-span">
                                                    {productData?.itemsSoldPercentage || "-"}
                                                </span>
                                                {productData?.itemsSoldPercentage ? (
                                                    <span className="_93-9-span2">%</span>
                                                ) : (
                                                    ""
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="title">
                                    <div className="heading-4-total-visitors3">of overall stock</div>
                                </div>
                            </div>
                            <div className="frame3">
                                <div className="title">
                                    <div className="heading-4-total-visitors2">WS STOCK</div>
                                    <Tooltip
                                        color="#10141b"
                                        overlayInnerStyle={{ textAlign: "center" }}
                                        title={<>Supplier‑side stock available for order or reorder.</>}>
                                        <InfoCircle
                                            className={`info-circle7 ${pageEnabled ? "text-white" : "text-inactive"}`}
                                        />
                                    </Tooltip>
                                </div>
                                <div className="content3">
                                    <div className="frame-3132894">
                                        <div className="_102">{productData?.supplierStock || "-"}</div>
                                    </div>
                                </div>
                                <div className="title">
                                    <div className="heading-4-total-visitors3"># of items</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ShelfSpeedStyled>
    );
}; // Shelf speed and stock component
